import type { CoopCancelReasonType } from '@app/DashboardComponents/CoopCancelAppointmentComponent';
import axios from 'axios';

const cancelTour = async (
  tourId: string,
  details?: string,
  reason?: CoopCancelReasonType,
) => {
  await axios.post(`/tours/${tourId}/cancel_tour`, {
    details,
    reason,
  });
};

export default cancelTour;
